<section class="hero">
  <div class="hero-body">
    <div class="container">
      <ng-content></ng-content>
    </div>
  </div>
</section>
